<div class="protocol-vs">
  <div class="protocol-vs__header">
    <app-details-header
      title="VS｜ビデオ聴診記録" i18n-title="@@details.protocolVs.headerTitle"
      badgeText="観察記録" i18n-badgeText="@@details.protocolVs.badgeText"
      badgeColor="#E65100"
      [patientName]="patientName()"
      [measureDate]="measureDate()"
      [measurer]="measurer()" />
  </div>

  <div class="protocol-vs__body">
    <!-- Observation Summary Chips -->
    @if (measurementReady()) {
      <app-observation-chips
        [swallowCount]="swallowCount()"
        [coughCount]="coughCount()"
        [durationSec]="durationSec()" />
    } @else {
      <div class="zone-skeleton zone-skeleton--chips" role="status" aria-busy="true"
           i18n-aria-label="@@details.protocolVs.skeleton.chipsAria" aria-label="計測サマリーを読み込み中">
        <span class="zone-skeleton__chip"></span>
        <span class="zone-skeleton__chip"></span>
        <span class="zone-skeleton__chip"></span>
      </div>
    }

    <!-- Timeline Card (video + posture + wave + events) -->
    <div class="timeline-card">
      <div class="timeline-card__header">
        <div class="timeline-card__header-left">
          <mat-icon class="timeline-card__icon">sync</mat-icon>
          <span class="timeline-card__title">
            <span class="timeline-card__title-main" i18n="@@details.protocolVs.syncViewTitle">同期ビュー</span>
            <span class="timeline-card__title-detail" i18n="@@details.protocolVs.syncViewSubtitle"> — 映像・姿勢・波形・イベント</span>
          </span>
        </div>
        <span class="timeline-card__duration">
          <span i18n="@@details.protocolVs.recordingDurationLabel">録音時間: </span>{{ recordData()?.data?.totalTime ?? '' }}
        </span>
      </div>

      <div class="timeline-card__grid">
        <!-- Video -->
        <div class="timeline-card__video">
          <!-- ローディングはカードが単一オーナーとして担う（mediaLoading でデータ到着前から統一シマー表示）。 -->
          <app-measured-data-video-card
            [mediaRecordData]="mediaRecordData()"
            [recordData]="recordData()"
            [playerSnapshot]="playerSnapshot()"
            [playbackEnded]="playbackEnded()"
            [audioMutedOverride]="audioMutedOverride()"
            [showWaveCard]="false"
            [mediaLoading]="!videoReady()"
            [recordLoadingSuccess]="recordLoadingSuccess()"
            (videoHostReady)="videoHostReady.emit($event)"
            (videoPlayToggle)="videoPlayToggle.emit()"
            (videoSeekTo)="videoSeekTo.emit($event)"
            (videoRateChange)="videoRateChange.emit($event)"
            (videoMuteToggle)="videoMuteToggle.emit()" />
        </div>

        <!-- Posture (Neck Angle) -->
        <div class="timeline-card__posture">
          @if (postureReady()) {
            <app-measured-data-neck-angle-card
              [frameless]="true"
              [chartOption]="chartOption()"
              [currentChartOption]="currentChartOption()"
              [currentOrientation]="currentOrientation()"
              (chartInit)="chartInit.emit($event)"
              (currentChartInit)="currentChartInit.emit($event)" />
          } @else {
            <div class="zone-skeleton zone-skeleton--posture" role="status" aria-busy="true"
                 i18n-aria-label="@@details.protocolVs.skeleton.postureAria" aria-label="姿勢データを読み込み中">
              <div class="zone-skeleton__shimmer"></div>
              <span class="zone-skeleton__label" i18n="@@details.protocolVs.skeleton.postureLabel">姿勢データを読み込み中…</span>
            </div>
          }
        </div>

        <!-- Waveform -->
        @if (showWaveCard()) {
          <div class="timeline-card__wave">
            <app-measured-data-wave-card
              [frameless]="true"
              [recordData]="recordData()"
              [recordtype]="recordtype()"
              [recordLoadingSuccess]="recordLoadingSuccess()"
              [waveLoadingPercent]="waveLoadingPercent()"
              [waveProcessing]="waveProcessing()"
              [waveDownloading]="waveDownloading()"
              [waveDownloadPercent]="waveDownloadPercent()"
              [waveErrorMessage]="waveErrorMessage()"
              [selectedEvent]="selectedEvent()"
              [currentStartOffset]="currentStartOffset()"
              [playing]="playing()"
              [timelineOffsetReference]="timelineOffsetReference()"
              [zoomValue]="zoomValue()"
              [showMiniPlayback]="canPlayWaveStandalone()"
              [allowVideoModePlayback]="canPlayWaveStandalone()"
              [avSyncFrontTrimRatio]="avSyncFrontTrimRatio()"
              [avSyncEndTrimRatio]="avSyncEndTrimRatio()"
              (offsetToggle)="offsetToggle.emit($event)"
              (seek)="seek.emit($event)"
              (playPauseClicked)="playPauseClicked.emit()"
              (zoomMinusClicked)="zoomMinusClicked.emit()"
              (zoomResetClicked)="zoomResetClicked.emit()"
              (zoomPlusClicked)="zoomPlusClicked.emit()" />
          </div>
        }

        <!-- Event Table -->
        <div class="timeline-card__events">
          @if (measurementReady()) {
            <app-event-table
              [events]="events()"
              (seekToEvent)="onEventSeek($event)" />
          } @else {
            <div class="zone-skeleton zone-skeleton--events" role="status" aria-busy="true"
                 i18n-aria-label="@@details.protocolVs.skeleton.eventsAria" aria-label="イベント表を読み込み中">
              <div class="zone-skeleton__row"></div>
              <div class="zone-skeleton__row"></div>
              <div class="zone-skeleton__row"></div>
              <div class="zone-skeleton__row"></div>
              <span class="zone-skeleton__label" i18n="@@details.protocolVs.skeleton.eventsLabel">イベントを解析中…</span>
            </div>
          }
        </div>

        <!-- Data Footer -->
        <div class="timeline-card__footer">
          <app-data-footer
            [dataId]="dataId()"
            nbModel="nbModel v2.1"
            [downloadUrl]="downloadUrl()" />
        </div>
      </div>
    </div>

    <!-- Disclaimer -->
    <app-disclaimer [message]="disclaimer" />
  </div>
</div>
